import { create } from "zustand"

export interface DbPoolStatus {
  pool_size: number
  checked_in: number
  checked_out: number
  overflow: number
}

interface DbPoolStore extends DbPoolStatus {
  updateDbStatus: (status: DbPoolStatus) => void
}

export const useDbPoolStore = create<DbPoolStore>((set, get) => ({
  pool_size: 0,
  checked_in: 0,
  checked_out: 0,
  overflow: 0,
  updateDbStatus: (status) => set(status),
}))
